
import React, { Component } from 'react';

import loader from '../../img/ripple.svg';

class Loader extends Component {

  render() {

    return (
      <div className="loader">
        <img src={ loader } alt="loader" />
      </div>
    );
  }
}

export default Loader;
